import BaseHighlights from './BaseHighlights';

export { type BaseHighlightsProps } from './BaseHighlights';
export default BaseHighlights;
